/* eslint-disable react/jsx-curly-newline */
import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import classes from './Home.module.css';
import config from 'helpers/Config';

const Header = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  const { settings } = props;
  const history = useHistory();

  const btn1 = Object.prototype.hasOwnProperty.call(
    settings,
    'header_btn1_new_tab'
  );
  const btn2 = Object.prototype.hasOwnProperty.call(
    settings,
    'header_btn2_new_tab'
  );

  const btn3 = Object.prototype.hasOwnProperty.call(
    settings,
    'header_btn3_new_tab'
  );
  const toggleNavbar = () => setCollapsed(!collapsed);

  const closeHandler = (value) => {
    window.location = value;
  };

  const iconClickHandler = () => {
    history.replace("/");
  }

  const showLinkHandler = (e, value, show) => {
    e.preventDefault();
    if (show === false) {
      window.location = value;
    } else {
      window.open(value);
    }
  };

  const showNavToggle = settings.header_btn1_url.length || 
  settings.header_btn2_url.length || 
  settings.header_btn2_url.length


  return (
    <>
      <Navbar
        color="faded"
        className={`${classes.mwb_main_home_header} navbar-expand-lg`}
        light
      >
        <NavbarBrand className={classes.header_title}>
          {settings.header_logo_url !== '' ? (
            <img
              src={settings.header_logo_url}
              alt="dummy"
              style={{ maxWidth: '130px', maxHeight: '40px' }}
              onClick={() => iconClickHandler()}
              className={classes.navbar_brand_img}
            />
          ) : (
            ''
          )}
        </NavbarBrand>
        <div>
          <NavbarToggler
            onClick={toggleNavbar}
            className={ showNavToggle ? classes.nav_toggle : classes.hide_nav_toggle}
          />
          <button
            type="button"
            name="headerclose"
            className={`${classes.close_btn} ${classes.mwb_mobile} btn`}
            onClick={() => closeHandler(settings.header_back_btn_url)}
          >
            <svg
              className="icon fill"
              width="24px"
              height="24px"
              role="img"
              fill=""
            >
              <path
                id="close-lg-ico-a"
                d="M19.7 18.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L12 13.4l-6.3 6.3c-.4.4-1 .4-1.4 0-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7l6.3-6.3-6.3-6.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l6.3 6.3 6.3-6.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L13.4 12l6.3 6.3z"
              />
            </svg>
          </button>
        </div>

        <Collapse
          isOpen={!collapsed}
          navbar
          className={classes.home_icons_list}
        >
          <Nav className={` ${classes.mwb_dir}`} navbar>
            {settings.header_btn1_url !== '' ? (
              <NavItem className={classes.mwb_nav_list}>
                <div>
                  <button
                    type="button"
                    name="headerbtn0"
                    className={`btn ${classes.head_list_btn1}`}
                    onClick={(e) =>
                      showLinkHandler(e, settings.header_btn1_url, btn1)
                    }
                  >
                    {settings.header_btn1_text}
                  </button>
                </div>
              </NavItem>
            ) : (
              ' '
            )}
            {settings.header_btn2_url !== '' ? (
              <NavItem className={classes.mwb_nav_list}>
                <div>
                  <button
                    type="button"
                    name="headerbtn1"
                    className={`btn ${classes.head_list_btn2}`}
                    onClick={(e) =>
                      showLinkHandler(e, settings.header_btn2_url, btn2)
                    }
                  >
                    {settings.header_btn2_text}
                  </button>
                </div>
              </NavItem>
            ) : (
              ' '
            )}

            {settings.header_btn3_url !== '' ? (
              <NavItem className={classes.mwb_nav_list}>
                <div>
                  <button
                    type="button"
                    name="headerbtn3"
                    className={`btn ${classes.head_list_btn3}`}
                    onClick={(e) =>
                      showLinkHandler(e, settings.header_btn3_url, btn3)
                    }
                  >
                    {settings.header_btn3_text}
                  </button>
                </div>
              </NavItem>
            ) : (
              ' '
            )}
            <NavItem className={`${classes.mwb_desktop} ${classes.closeicon}`}>
              <div>
                <button
                  type="button"
                  aria-label="close"
                  className={`${classes.close_btn} btn`}
                  onClick={() => closeHandler(settings.header_back_btn_url)}
                >
                  <svg
                    className="icon fill"
                    width="24px"
                    height="24px"
                    role="img"
                    fill=""
                  >
                    <title>Circle</title>
                    <path
                      id="close-lg-ico-a"
                      d="M19.7 18.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3L12 13.4l-6.3 6.3c-.4.4-1 .4-1.4 0-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7l6.3-6.3-6.3-6.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l6.3 6.3 6.3-6.3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L13.4 12l6.3 6.3z"
                    />
                  </svg>
                </button>
              </div>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </>
  );
};

Header.propTypes = {
  settings: PropTypes.object,
};

const mapStateToProps = (store) => {
  return {
    settings: store.list.settings,
  };
};

export default connect(mapStateToProps, null)(Header);
